<template>
  <div>
    <template>
      <div class="modal is-active" v-if="showModal">
        <div class="modal-background"/>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Confirm Decision
            </p>
            <button
              class="icon is-right"
              @click.prevent="toggleModal()"
              ref="closeIcon"
            >
              <font-awesome-icon :icon="['fal', 'times']" title="Close" />
            </button>
          </header>
          <section class="modal-card-body">
            <div class="modal-body">
              Are you sure you want to make a "Not Duplicate" decision for this record?
            <br/>
            <br/>
            </div>
            <div class="update-box">
              <button @click.prevent="toggleModal()"
                class="button button-link has-underline"
              >
                Cancel
              </button>
              <button
                class="button is-primary"
                @click="removeFromList()"
              >
                Yes Not Duplicate
              </button>
            </div>
          </section>
        </div>
      </div>
    </template>
    <es-loader v-if="loading" style="margin: 6.5rem"/>
    <es-exception v-else-if="loadingError"
      style="padding: 6.5rem"
      margin="0rem" size="4x"
      exceptionMessage="There was an issue. Please contact the admin"
    />
    <div v-else class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">
              <div>
                Duplicate Group Details
              </div>
            </div>
          </template>
        </es-header>
      </div>
      <es-exception v-if="!searchResults.length"
        style="padding: 6.5rem"
        margin="0rem" size="4x"
        exceptionMessage="No records to review."
      />
      <div class="table-container" v-else style="padding: 2rem 3rem 1rem">
        <table class="table is-fullwidth is-hoverable">
          <es-sorter
            :columnHeaders="filteredColumnHeader"
          />
          <tbody>
            <tr v-for="(record,index) in searchResults" :key="index">
              <td style="padding-top: 0.7rem" v-if="searchType === 'queue'">
                <input
                  title="Select Item"
                  style="width: 15px; height: 15px;"
                  type="checkbox"
                  v-model="itemSelected"
                  :value="record.personId"
                >
              </td>
              <td class="weighted-font">
                {{ formatStateID(record.personId) }}
              </td>
              <td class="weighted-font">
                {{ record.student.lastName }}, {{ record.student.firstName }}
              </td>
              <td>
                <div>
                  <router-link
                    :to="{
                      name: 'PIDistrictInfoDetails',
                      params: {
                        code: record.student.districtCode,
                      },
                    }"
                    class="has-text-weight-bold has-text-primary" style="font-size:14px"
                  >
                    {{ record.student.district.location.name }}
                  </router-link>
                  <span class="padding-left--small has-text-grey">
                    ({{ record.student.districtCode }})
                  </span>
                </div>
                <div>
                  <router-link
                    :to="{
                      name: 'PISchoolInfoDetails',
                      params: {
                        districtCode: record.student.districtCode,
                        schoolCode: record.student.schoolCode,
                      },
                    }"
                    class="is-italic"
                  >
                    {{ record.student.school.location.name }}
                  </router-link>
                  <span class="padding-left--small has-text-grey is-italic">
                    ({{ record.student.schoolCode }})
                  </span>
                </div>
              </td>
              <td class="weighted-font">
                {{ record.student.dateOfBirth }}
              </td>
              <td>
                <div class="has-text-weight-bold">
                  {{ (record.student.localId && fieldEnabled('LOCAL_STUDENT_ID')) ? record.student.localId : '--' }}
                </div>
                <div class="has-text-grey">
                  {{ record.student.sourceCode }}
                </div>
              </td>
              <td>
                {{ record.student.genderCode ? mapGender(record.student.genderCode) : null }}
              </td>
              <td>
                {{ formatMMDDYYYY(record.student.lastUpdateDate) }}
              </td>
              <td>
                {{
                  record.student.activeHistoryCount ? record.student.activeHistoryCount
                    : (record.activeHistoryCount ? record.activeHistoryCount : 0)
                }}
              </td>
              <td>
                <div class="select">
                  <select
                    v-model="record.decision"
                    title="Decision">
                    <option
                      v-for="(item, id) in dropDownOptions"
                      :key="id"
                      :value="item.code"
                      :disabled="item.isDisabled === true"
                    >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="is-flex flex-justify--end flex-align--center"
        style="margin-right: 5.15rem; padding-bottom: 1rem"
      >
        <button
          class="button button-link has-underline"
          @click="returnToDuplicate"
        >
          Return to Duplicate List
        </button>
        <button
          v-if="searchType === 'queue'"
          :class="{ 'disable': !this.itemSelected.length }"
          class="button button-link has-underline"
          @click.prevent="toggleModal()"
          style="margin-right: 1rem"
          :disabled="!this.itemSelected.length"
          ref="btnNotDup"
        >
          Not a Duplicate (Remove from List)
        </button>
        <button
          :class="{ 'disable': this.idToRetire.length === 0 }"
          class="button is-primary"
          @click="review"
          :disabled="this.idToRetire.length === 0"
        >
          Review
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsSorter from '@/components/EsSorter.vue';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import FieldLabels from '@/mixins/FieldLabels';
import StateIdUtils from '@/mixins/StateIdUtils';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

library.add(
  faAngleDoubleRight,
);

export default {
  mixins: [
    FieldLabels,
    StateIdUtils,
    AccessibilityUtils,
  ],
  components: {
    EsException,
    EsHeader,
    EsLoader,
    EsSorter,
  },
  props: {
    dupGroupDetails: {
      type: Array,
    },
    groupId: {
      type: Number,
    },
    queueId: {
      type: Number,
    },
    searchType: {
      type: String,
    },
    personTypeQueue: {
      type: String,
    },
  },
  watch: {
    idToMerge() {
      if (this.idToMerge.length) {
        this.$emit('idToMerge', this.idToMerge[0].personId);
      } else {
        this.$emit('idToMerge', null);
      }
    },
    idToRetire() {
      if (this.idToRetire.length) {
        this.$emit('idToRetire', this.idToRetire[0].personId);
      } else {
        this.$emit('idToRetire', null);
      }
    },
  },
  data() {
    return {
      apiSorter: {},
      columnHeaders: [],
      itemSelected: [],
      loading: false,
      loadingError: false,
      results: {},
      searchResults: this.searchType === 'queue' ? this.dupGroupDetails.filter(x => x.verifiedNoDup === false) : this.dupGroupDetails,
      showModal: false,
      personType: null,
    };
  },
  async created() {
    await this.loadPersonTypes();
    if (this.searchType === 'session') {
      this.personType = this.$route.query.personType ? this.$route.query.personType : this.defaultPersonType;
    } else if (this.searchType === 'queue') {
      this.personType = this.personTypeQueue ? this.personTypeQueue : this.defaultPersonType;
    }

    this.columnHeaders = [
      {
        header: null,
        field: null,
        sortable: false,
        order: null,
        style: 'width: 1%;',
        show: this.searchType === 'queue',
      },
      {
        header: `${this.getFieldLabel(`PER:${this.personType}:ASSIGN:STATE_STUDENT_ID`)}`,
        field: 'stateId',
        sortable: true,
        order: null,
        show: true,
      },
      {
        header: 'Name',
        field: 'firstname',
        sortable: true,
        order: null,
        show: true,
      },
      {
        header: 'Location Info',
        field: 'locationInfo',
        sortable: true,
        order: null,
        show: true,
      },
      {
        header: `${this.getFieldLabel(`PER:${this.personType}:ASSIGN:DATE_OF_BIRTH`)}`,
        field: 'dob',
        sortable: true,
        order: null,
        show: true,
      },
      {
        header: 'ID Info',
        sortable: true,
        order: null,
        show: true,
      },
      {
        header: `${this.getFieldLabel(`PER:${this.personType}:ASSIGN:GENDER_CODE`)}`,
        field: 'gender',
        sortable: true,
        order: null,
        show: true,
      },
      {
        header: 'Last Updated',
        sortable: true,
        order: 'DESC',
        show: true,
      },
      {
        header: '# of History Records',
        field: 'count',
        sortable: false,
        order: null,
        show: true,
      },
      {
        header: 'Decision',
        sortable: false,
        order: null,
        style: 'width: 225px',
        show: true,
      },
    ];
  },
  mounted() {
    this.onLoad();
  },
  computed: {
    filteredColumnHeader() {
      return this.columnHeaders.filter(f => f.show);
    },
    ...mapGetters('lookups', [
      'activeGenders',
      'defaultPersonType',
    ]),
    disableMergeSelection() {
      if (this.idToMerge.length) {
        return true;
      } return false;
    },
    disableRetireSelection() {
      if (this.idToRetire.length) {
        return true;
      } return false;
    },
    dropDownOptions() {
      const menuItems = [];
      menuItems.push({
        code: 'retire',
        description: 'ID to retire',
        isDisabled: this.disableRetireSelection === true,
      });
      menuItems.push({
        code: 'merge',
        description: 'ID to merge',
        isDisabled: this.disableMergeSelection === true,
      });
      menuItems.push({
        code: null,
        description: 'No Merge / No Retire',
        isDisabled: false,
      });
      return menuItems;
    },
    idToMerge() {
      return this.searchResults.filter(d => d.decision === 'merge');
    },
    idToRetire() {
      return this.searchResults.filter(d => d.decision === 'retire');
    },
    idsForComparePage() {
      return this.idToMerge.length ? this.idToRetire.concat(this.idToMerge) : this.idToRetire;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadGenders',
      'loadPersonTypes',
    ]),
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.personType);
    },
    mapGender(gender) {
      const item = this.activeGenders.find(r => r.code === gender);
      return item ? item.description : '\u00A0';
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.loadGenders(),
          // this.loadPersonTypes(),
        ]);
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.$nextTick(() => {
        const modalOpenFocus = this.$refs.closeIcon;
        const modalCloseFocus = this.$refs.btnNotDup;
        this.getFocusModal(modalOpenFocus, modalCloseFocus);
      });
    },
    async removeFromList() {
      this.toggleModal();
      this.loading = true;
      this.loadingError = false;
      this.itemSelected.forEach(async (person) => {
        const payload = {};
        payload.groupId = this.groupId;
        payload.verifiedNoDup = true;
        payload.personId = person;
        try {
          this.response = await axios({
            method: 'put',
            url: `idmanager/duplicates/${this.queueId}/groups/${this.groupId}/details`,
            data: payload,
          });
        } catch (err) {
          this.showError(err.response.data.message);
          this.loadingError = false;
        } finally {
          this.$emit('backToDupQueue');
          this.loading = false;
        }
      });
    },
    returnToDuplicate() {
      this.$emit('goBack');
    },
    review() {
      this.$emit('viewComparePage');
    },
    formatMMDDYYYY(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  table th
    max-width: 100%
    white-space: nowrap
  table td
    max-width: 100%
    white-space: nowrap
  .button-link
    font-size: 12px
  .disable
    pointer-events: none
    text-decoration: none
    opacity: 0.25
    color: #999
  .is-primary
    height: 2rem
    width: auto
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
    color: #444
    font-weight: 700
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
  .weighted-font
    font-weight: 700 !important
  .table-container
    overflow-x: auto
</style>
